var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bulk-users-modal", staticStyle: { position: "relative" } },
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay",
              attrs: { "data-cy": "loading-overlay" }
            },
            [
              _c("b-spinner", { attrs: { variant: "primary" } }),
              _c("p", [
                _vm._v("Procesando usuarios masivos, por favor espere...")
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "h3",
        { staticClass: "import-title", attrs: { "data-cy": "modal-title" } },
        [_vm._v("Creación masiva de usuarios")]
      ),
      _vm._m(0),
      _vm._m(1),
      _vm.errorArchivo
        ? _c(
            "div",
            { staticClass: "error-txt", attrs: { "data-cy": "file-error" } },
            [_vm._v(_vm._s(_vm.errorArchivo))]
          )
        : _vm._e(),
      !_vm.archivo
        ? _c(
            "div",
            { staticClass: "btn-row" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "text.primary import-btn",
                  attrs: {
                    icon: "file_download",
                    loading: _vm.cargandoCsv,
                    "data-cy": "download-csv-example"
                  },
                  on: {
                    click: function($event) {
                      return _vm.descargarEjemplo("csv")
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.cargandoCsv
                          ? "Descargando..."
                          : "Descargar CSV ejemplo"
                      ) +
                      " "
                  )
                ]
              ),
              _c(
                "vs-button",
                {
                  staticClass: "text.primary import-btn",
                  attrs: {
                    icon: "file_download",
                    loading: _vm.cargandoExcel,
                    "data-cy": "download-excel-example"
                  },
                  on: {
                    click: function($event) {
                      return _vm.descargarEjemplo("excel")
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.cargandoExcel
                          ? "Descargando..."
                          : "Descargar Excel ejemplo"
                      ) +
                      " "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "btn-row" },
        [
          !_vm.archivo
            ? _c(
                "vs-button",
                {
                  staticClass: "import-btn upload",
                  attrs: {
                    color: "primary",
                    icon: "file_upload",
                    "data-cy": "btn-select-file"
                  },
                  on: { click: _vm.openFileDialog }
                },
                [_vm._v(" Selecciona un archivo ")]
              )
            : _c(
                "div",
                {
                  staticClass: "file-row",
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    gap: "10px",
                    "justify-content": "center"
                  }
                },
                [
                  _c(
                    "vs-chip",
                    {
                      staticClass: "file-chip",
                      attrs: { color: "primary", "data-cy": "file-name" }
                    },
                    [_vm._v(_vm._s(_vm.archivo.name))]
                  ),
                  _c(
                    "vs-button",
                    {
                      staticStyle: {
                        "min-width": "32px",
                        "font-size": "1.1rem",
                        padding: "6px 8px"
                      },
                      attrs: {
                        type: "flat",
                        color: "primary",
                        icon: "file_upload",
                        "data-cy": "btn-change-file"
                      },
                      on: { click: _vm.openFileDialog }
                    },
                    [_vm._v(" Cambiar archivo ")]
                  )
                ],
                1
              ),
          _c("input", {
            ref: "archivo",
            staticStyle: { display: "none" },
            attrs: {
              type: "file",
              accept: ".csv,.xlsx",
              "data-cy": "input-file"
            },
            on: { change: _vm.handleFileUpload }
          })
        ],
        1
      ),
      _vm.archivo
        ? _c(
            "div",
            { staticClass: "btn-row" },
            [
              _c(
                "vs-button",
                {
                  staticClass: "finish-btn",
                  attrs: {
                    color: "success",
                    loading: _vm.loading,
                    "data-cy": "btn-create-users"
                  },
                  on: { click: _vm.procesarMasivo }
                },
                [_vm._v(" Crear Usuarios ")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.uploadProgress > 0 && _vm.uploadProgress < 100
        ? _c(
            "div",
            {
              staticClass: "prog-row",
              attrs: { "data-cy": "progress-bar-container" }
            },
            [
              _c("progress", {
                attrs: { max: "100", "data-cy": "progress-bar" },
                domProps: { value: _vm.uploadProgress }
              }),
              _c("span", { attrs: { "data-cy": "progress-percentage" } }, [
                _vm._v(_vm._s(_vm.uploadProgress) + "%")
              ])
            ]
          )
        : _vm._e(),
      _vm.mensaje
        ? _c(
            "div",
            {
              staticClass: "alert alert-info msg-row",
              attrs: { "data-cy": "success-message" }
            },
            [_vm._v(" " + _vm._s(_vm.mensaje) + " ")]
          )
        : _vm._e(),
      _vm.errorCreacion
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger msg-row",
              attrs: { "data-cy": "error-message" }
            },
            [_vm._v(_vm._s(_vm.errorCreacion) + " ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "modal-desc", attrs: { "data-cy": "modal-description" } },
      [
        _vm._v(" Adjunta un archivo "),
        _c("strong", [_vm._v("CSV")]),
        _vm._v(" o "),
        _c("strong", [_vm._v("Excel")]),
        _vm._v(
          ' con los siguientes campos, en el orden exacto y separados por ";". '
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ol",
      { staticClass: "fields-list", attrs: { "data-cy": "fields-list" } },
      [
        _c("li", [
          _c("span", { staticClass: "field-label" }, [_vm._v("Rut:")]),
          _vm._v(" Usuario sin puntos, con guion. Ej: xxxxxxxx-x")
        ]),
        _c("li", [
          _c("span", { staticClass: "field-label" }, [_vm._v("Nombre:")]),
          _vm._v(" Nombre usuario")
        ]),
        _c("li", [
          _c("span", { staticClass: "field-label" }, [_vm._v("Apellidos:")]),
          _vm._v(" Apellidos usuario")
        ]),
        _c("li", [
          _c("span", { staticClass: "field-label" }, [_vm._v("Alias:")]),
          _vm._v(" Alias usuario")
        ]),
        _c("li", [
          _c("span", { staticClass: "field-label" }, [_vm._v("Correo:")]),
          _vm._v(" Correo de contacto")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }